export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00815.cc65c305.png";